var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelthfarmLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0v30H0v40h30v30h40V70h30V30H70V0zm3 3h34v30h30v34H67v30H33V67H3V33h30zm0 0",
    fill: "#00923d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 6v30H6v28h30v30h28V64h30V36H64V6zm0 0",
    fill: "#00923d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 39.2c-.4 2.3-2.3 4.7-3.7 5.9-2 1.6-7.3 2.5-7.3 2.5l-.2 30 4.6 3h-13l4.7-3v-30s-5-.7-7-2.3a14 14 0 0 1-5-6.4 36.5 36.5 0 0 0 27 .3zm0 0",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 29c2.2-.7 4.5-1.1 6.8-.4 3 .8 5.7 3.6 6.4 6.5.6 2.4 0 5.2-1.3 7.4-1.7 3-5 4.7-7.7 6.7-3.3 2.4-6.9 4.5-10.5 6.6-2.4 1.4-4.9 2.6-7.3 3.9-2.3 1.3-2 2.6-.8 3.7 2.8 2.3 5.7 4.5 8 7.2 1 1 2 2.2 2.4 3.5.4 1.3.6 2.8 0 4-.6 1.3-1.8 2.4-3.3 2.6-3.1.6-5.6 0-10-1.8 3.1.5 8.5 2.1 11.2-.5.7-.6.6-2 .3-2.9-.3-1.2-1.4-2-2.2-3-2.7-2.8-6-4.5-8.9-7.4-.9-.9-1.7-1.5-1.9-3.4-.1-1.5 1-3.2 2.4-4.1 4.1-2.7 8.6-4.9 12.6-7.7 3.5-2.3 7.5-4.3 10-7.6.8-1 1.4-2.4 1.6-3.7.1-1.2 0-2.7-.6-3.7a5.8 5.8 0 0 0-3.9-2.6c-1.8-.2-3.7.9-5.3 1.8-1.6.8-2.9 2.2-4.3 3.3-1 .7-1.6 1.7-2.7 2-1.6.4-3.4 0-5-.3-.8-.2-1.7-1-1.7-1.7 0-1.1 1.7-1.4 2.5-2.2.4-.4.6-1.1 1-1.5 1-.4 2-.5 3-.3 1 0 1.3.6 2.5.4 2.5-1.6 4.3-3.7 6.7-4.7zm0 0",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelthfarmLogo);
export default __webpack_public_path__ + "static/media/helthfarm-logo.a4414d4ec5c3900d7d3260a085f8218e.svg";
export { ForwardRef as ReactComponent };